import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import { SrOnly } from '../Helper/SrOnly/SrOnly';
import Svg from '../Svg';
import ButtonBase from './ButtonBase';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "IconButton-root_28s6H",
  "wrapper": "IconButton-wrapper_3WVVa",
  "icon": "IconButton-icon_kRNru",
  "sizeDefault": "IconButton-sizeDefault_3bsV6",
  "sizeSmall": "IconButton-sizeSmall_MYQrp"
};
function IconButton({
  icon,
  shape = 'compact',
  small,
  children,
  className,
  ...extraProps
}, ref) {
  return /*#__PURE__*/_jsx(ButtonBase, {
    ref: ref,
    shape: shape,
    small: small,
    className: clsx(styles.root, {
      [styles.sizeDefault]: !small,
      [styles.sizeSmall]: small
    }, className),
    ...extraProps,
    children: /*#__PURE__*/_jsxs(Base, {
      tagName: "span",
      className: styles.wrapper,
      children: [/*#__PURE__*/_jsx(Svg, {
        name: icon,
        className: styles.icon
      }), /*#__PURE__*/_jsx(SrOnly, {
        children: children
      })]
    })
  });
}
const Export = /*#__PURE__*/React.forwardRef(IconButton);
Export.displayName = 'IconButton';
export { Export as IconButton };